'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Spring = require('./Spring.js');

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class ScrollSpring {
  constructor() {
    __publicField(this, "done");
    __publicField(this, "to");
    __publicField(this, "_spring");
    __publicField(this, "_pos");
    __publicField(this, "_speed");
    __publicField(this, "_correctSpeed");
    this._spring = new Spring.Spring();
    this._pos = 0;
    this.to = 0;
  }
  start(speed, pos, to) {
    this._speed = speed;
    this._pos = pos;
    this.to = to;
    this.done = false;
    this._spring.x = this._pos;
    this._spring.tx = this.to;
    const diff = this.to - this._pos;
    const toDirection = Math.abs(diff) / diff;
    const currentDirection = Math.abs(this._speed) / this._speed;
    if (toDirection !== currentDirection) {
      this._correctSpeed = true;
    } else {
      this._correctSpeed = false;
    }
  }
  update() {
    if (this._correctSpeed) {
      this._speed *= 0.6;
      if (Math.abs(this._speed) < 2) {
        this._correctSpeed = false;
      }
      this._pos += this._speed;
      this._spring.x = this._pos;
    } else {
      const diff = this.to - this._pos;
      if (Math.abs(diff) < 0.05) {
        this._pos = this.to;
        this.done = true;
      } else {
        this._spring.tx = this.to;
        this._spring.update();
        this._pos = this._spring.x;
      }
    }
    return this._pos;
  }
  cancel() {
  }
}

exports.default = ScrollSpring;
//# sourceMappingURL=ScrollSpring.js.map
